module.exports = __webpack_public_path__ + "img/vessel_visitation_5_63021.5f7544bd.jpg";